import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _blogTag = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _categoryWithTranslations = { coverImage: '_image' };
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getRelatedPostsMetadataRequest = {};
var _getRelatedPostsMetadataResponse = {
    relatedPostsMetadata: '_relatedPostMetadata',
};
var _getRelatedPostsRequest = {};
var _getRelatedPostsResponse = {
    relatedPosts: '_relatedPost',
    categories: '_categoryWithTranslations',
    tags: '_blogTag',
};
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _media = { wixMedia: '_wixMedia' };
var _metrics = { averageRating: 'FLOAT' };
var _relatedPost = { media: '_media' };
var _relatedPostMetadata = { metrics: '_metrics' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
var _wixMedia = { image: '_image', videoV2: '_videoV2' };
function resolveComWixpressNpmBlogFrontendAdapterPublicV2RelatedPostsWidgetServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/blog-frontend-adapter-public',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-list-widget/render-model',
                destPath: '/v2/post-list-widget/render-model',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-feed-page',
                destPath: '/v2/post-feed-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public/v2/post-page',
                destPath: '/v2/post-page',
            },
            {
                srcPath: '/_api/blog-frontend-adapter-public',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns aggregated data for a post page. */
export function getRelatedPosts(payload) {
    var _a = serializer(_getRelatedPostsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRelatedPostsResponse, {
        _blogTag: _blogTag,
        _categoryWithTranslations: _categoryWithTranslations,
        _focalPoint: _focalPoint,
        _image: _image,
        _media: _media,
        _relatedPost: _relatedPost,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __getRelatedPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.frontend_adapter_public.v2.related_post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.blog.frontend.adapter.public.v2.RelatedPostsWidgetService.GetRelatedPosts',
            url: resolveComWixpressNpmBlogFrontendAdapterPublicV2RelatedPostsWidgetServiceUrl({
                protoPath: '/v2/related-posts-widget/{postId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRelatedPosts.fromReq = fromReq;
    __getRelatedPosts.__isAmbassador = true;
    return __getRelatedPosts;
}
/** Updates and returns metadata for related posts (counters). */
export function getRelatedPostsMetadata(payload) {
    var _a = serializer(_getRelatedPostsMetadataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRelatedPostsMetadataResponse, {
        _metrics: _metrics,
        _relatedPostMetadata: _relatedPostMetadata,
    }).fromJSON;
    function __getRelatedPostsMetadata(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.frontend_adapter_public.v2.related_post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.blog.frontend.adapter.public.v2.RelatedPostsWidgetService.GetRelatedPostsMetadata',
            url: resolveComWixpressNpmBlogFrontendAdapterPublicV2RelatedPostsWidgetServiceUrl({
                protoPath: '/v2/related-posts-widget-metadata/{postId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRelatedPostsMetadata.fromReq = fromReq;
    __getRelatedPostsMetadata.__isAmbassador = true;
    return __getRelatedPostsMetadata;
}
//# sourceMappingURL=http.impl.js.map